import Vue from 'vue';
import priceFieldTransformer from './../../transformers/priceField';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(priceFieldTransformer.fetch(errors));
};

export default (id, priceField) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/price_fields/${id}`, priceField)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/priceField/update.js